/* eslint-disable no-case-declarations */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, AppState } from './AppProvider'

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case 'TOGGLE_CHAT_HISTORY':
      return { ...state, isChatHistoryOpen: !state.isChatHistoryOpen }
    case 'UPDATE_CURRENT_CHAT':
      return { ...state, currentChat: action.payload }
    case 'UPDATE_CHAT_HISTORY_LOADING_STATE':
      return { ...state, chatHistoryLoadingState: action.payload }
    case 'UPDATE_CHAT_HISTORY':
      if (!state.chatHistory || !state.currentChat) {
        return state
      }
      let conversationIndex = state.chatHistory.findIndex(
        (conv) => conv.id === action.payload.id
      )
      if (conversationIndex !== -1) {
        let updatedChatHistory = [...state.chatHistory]
        updatedChatHistory[conversationIndex] = state.currentChat
        return { ...state, chatHistory: updatedChatHistory }
      } else {
        return { ...state, chatHistory: [...state.chatHistory, action.payload] }
      }
    case 'UPDATE_CHAT_TITLE':
      if (!state.chatHistory) {
        return { ...state, chatHistory: [] }
      }
      let updatedChats = state.chatHistory.map((chat) => {
        if (chat.id === action.payload.id) {
          if (state.currentChat?.id === action.payload.id) {
            state.currentChat.title = action.payload.title
          }
          // Local-only — BE `/history/rename` returns 501 (singleton model).
          // This branch is unreachable in current setup: gated behind
          // `isCosmosDBAvailable.cosmosDB`, which is permanently `false`
          // because `/history/ensure` returns 501.
          return { ...chat, title: action.payload.title }
        }
        return chat
      })
      return { ...state, chatHistory: updatedChats }
    case 'DELETE_CHAT_ENTRY':
      if (!state.chatHistory) {
        return { ...state, chatHistory: [] }
      }
      let filteredChat = state.chatHistory.filter(
        (chat) => chat.id !== action.payload
      )
      state.currentChat = null
      // Local-only — BE `/history/delete` returns 501; sidebar gate
      // (`isCosmosDBAvailable.cosmosDB`) is permanently `false`, so this
      // action is never dispatched in our setup.
      return { ...state, chatHistory: filteredChat }
    case 'DELETE_CHAT_HISTORY':
      // Local-only — BE `/history/delete_all` returns 501; sidebar gate
      // permanently false → unreachable today.
      return {
        ...state,
        chatHistory: [],
        filteredChatHistory: [],
        currentChat: null,
      }
    case 'DELETE_CURRENT_CHAT_MESSAGES':
      // Local-only — BE `/history/clear` returns 501; sidebar gate
      // permanently false → unreachable today.
      if (!state.currentChat || !state.chatHistory) {
        return state
      }
      const updatedCurrentChat = {
        ...state.currentChat,
        messages: [],
      }
      return {
        ...state,
        currentChat: updatedCurrentChat,
      }
    case 'FETCH_CHAT_HISTORY':
      return { ...state, chatHistory: action.payload }
    case 'SET_COSMOSDB_STATUS':
      return { ...state, isCosmosDBAvailable: action.payload }
    default:
      return state
  }
}
